module.exports = __webpack_public_path__ + "static/media/natCapAdventures.1053ed6f.zip";